var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaylater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405.322,
    height: 374.809,
    viewBox: "0 0 405.322 374.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(-117.706 -314.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(145.138 399.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 377.89,
    height: 267.087,
    rx: 9.802,
    fill: "#65cefe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(159.14 411.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M496.512,392.064V603.712a16.222,16.222,0,0,1-16.222,16.222H455.807V389.551H150.937a6.854,6.854,0,0,1-6.854-6.854h0a6.854,6.854,0,0,1,6.854-6.855H480.29A16.223,16.223,0,0,1,496.512,392.064Z",
    transform: "translate(-144.083 -375.842)",
    fill: "#143a4d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(316.155 381.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M346.848,378.448c.333.408.668.817.99,1.235a57.945,57.945,0,1,1-82.552-9.39c.419-.344.839-.666,1.268-1A58.006,58.006,0,0,1,346.848,378.448Z",
    transform: "translate(-244.04 -357.209)",
    fill: "#f49b51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(302.095 367.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M325.325,350.606a71.99,71.99,0,1,0,51.42,87.871A71.986,71.986,0,0,0,325.325,350.606Zm37.837,84.319a57.943,57.943,0,1,1-42.954-71.116c.528.122,1.038.258,1.565.4a58.006,58.006,0,0,1,41.764,69.183C363.415,433.9,363.3,434.414,363.162,434.925Z",
    transform: "translate(-235.089 -348.24)",
    fill: "#fcc659"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(194.655 314.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M240.637,314.041a71.99,71.99,0,1,0,70.012,73.916A71.987,71.987,0,0,0,240.637,314.041Zm55.975,73.539a57.942,57.942,0,1,1-57.965-59.519c.542,0,1.07.016,1.613.031A58,58,0,0,1,296.628,386C296.628,386.525,296.628,387.053,296.612,387.579Z",
    transform: "translate(-166.693 -314.014)",
    fill: "#fcc659"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(208.69 328.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M278.435,344.2c.333.408.668.817.99,1.236a57.944,57.944,0,1,1-82.552-9.392c.421-.342.839-.666,1.268-1A58.009,58.009,0,0,1,278.435,344.2Z",
    transform: "translate(-175.627 -322.965)",
    fill: "#f49b51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(245.15 343.172) rotate(11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M51,0,47.092,8.936,35.923,10.991a17.841,17.841,0,0,1,3.656,3.88,21.624,21.624,0,0,1,2.659,5.4l12.082-2.223-3.907,8.935L43.7,28.213A21.594,21.594,0,0,1,42.479,35.9a19.613,19.613,0,0,1-3.974,6.616,24.039,24.039,0,0,1-6.7,5.091,32.448,32.448,0,0,1-9.337,3.106L61.511,79.45,47.228,82.079,9.474,54,8.012,46.05,15.9,44.6a32.457,32.457,0,0,0,6.744-1.963A20.559,20.559,0,0,0,27.9,39.5a14.543,14.543,0,0,0,3.48-4.165A11.84,11.84,0,0,0,32.8,30.219L3.321,35.644l3.907-8.935,24.056-4.428A12.764,12.764,0,0,0,24.64,15.9q-4.559-1.993-11.538-.708L0,17.6,3.907,8.666Z",
    fill: "#fcc659"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(354.301 389.326) rotate(11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68-2",
    "data-name": "Path 68",
    d: "M51,0,47.092,8.936,35.923,10.991a17.841,17.841,0,0,1,3.656,3.88,21.624,21.624,0,0,1,2.659,5.4l12.082-2.223-3.907,8.935L43.7,28.213A21.594,21.594,0,0,1,42.479,35.9a19.613,19.613,0,0,1-3.974,6.616,24.039,24.039,0,0,1-6.7,5.091,32.448,32.448,0,0,1-9.337,3.106L61.511,79.45,47.228,82.079,9.474,54,8.012,46.05,15.9,44.6a32.457,32.457,0,0,0,6.744-1.963A20.559,20.559,0,0,0,27.9,39.5a14.543,14.543,0,0,0,3.48-4.165A11.84,11.84,0,0,0,32.8,30.219L3.321,35.644l3.907-8.935,24.056-4.428A12.764,12.764,0,0,0,24.64,15.9q-4.559-1.993-11.538-.708L0,17.6,3.907,8.666Z",
    fill: "#fcc659"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(145.138 425.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 353.271,
    height: 263.71,
    rx: 9.503,
    fill: "#65cefe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(159.259 435.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(0 208.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M264.918,558.72H158.663a14.519,14.519,0,0,1-14.5-14.5V523.767h1.684v20.451a12.833,12.833,0,0,0,12.82,12.818H264.918Z",
    transform: "translate(-144.159 -523.767)",
    fill: "#143a4d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(146.558 241.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 32.75,
    height: 1.684,
    fill: "#143a4d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(171.783 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M406.763,434.032h-1.684v-28.19a12.832,12.832,0,0,0-12.818-12.818H253.517V391.34H392.261a14.518,14.518,0,0,1,14.5,14.5Z",
    transform: "translate(-253.517 -391.34)",
    fill: "#143a4d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(115.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 31.296,
    height: 1.684,
    fill: "#143a4d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(0.001 145.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 1.684,
    height: 39.801,
    fill: "#143a4d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(403.871 502.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M418.608,434.207v74.52a16.935,16.935,0,0,1-16.941,16.943H337.2a37.32,37.32,0,1,1,0-74.64h64.467a13.318,13.318,0,0,1,1.414.068A16.949,16.949,0,0,0,418.608,434.207Z",
    transform: "translate(-299.88 -434.207)",
    fill: "#143a4d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(9.275 29.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 17.415,
    cy: 17.415,
    r: 17.415,
    transform: "translate(0 24.628) rotate(-45)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(117.706 543.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M171.595,462.734a71.99,71.99,0,1,0,87.792,51.553A71.985,71.985,0,0,0,171.595,462.734Zm74.2,55.091a57.944,57.944,0,1,1-72.221-41.069c.52-.151,1.032-.284,1.557-.419A58,58,0,0,1,245.374,516.3C245.52,516.807,245.667,517.314,245.8,517.825Z",
    transform: "translate(-117.706 -460.4)",
    fill: "#fcc659"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(14.045 14.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M240.271,511.19c.146.507.294,1.013.426,1.525a57.944,57.944,0,1,1-72.224-41.073c.522-.149,1.034-.283,1.558-.418A58.007,58.007,0,0,1,240.271,511.19Z",
    transform: "translate(-126.647 -469.35)",
    fill: "#f49b51"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(20.698 19.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M130.883,485.007a25.253,25.253,0,0,1,11.481,12.045h0a25.342,25.342,0,0,1,11.5-12.069h0a25.289,25.289,0,0,1-11.5-12.044h0A25.313,25.313,0,0,1,130.883,485.007Z",
    transform: "translate(-130.883 -472.94)",
    fill: "#ffe6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(23.53 23.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M145.862,495.082a14.675,14.675,0,0,1,6.671,7h0a14.725,14.725,0,0,1,6.681-7.012h0a14.688,14.688,0,0,1-6.681-7h0A14.713,14.713,0,0,1,145.862,495.082Z",
    transform: "translate(-145.862 -488.07)",
    fill: "#ffe6a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 38.466, 38.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68-3",
    "data-name": "Path 68",
    d: "M51,0,47.092,8.936,35.923,10.991a17.841,17.841,0,0,1,3.656,3.88,21.624,21.624,0,0,1,2.659,5.4l12.082-2.223-3.907,8.935L43.7,28.213A21.594,21.594,0,0,1,42.479,35.9a19.613,19.613,0,0,1-3.974,6.616,24.039,24.039,0,0,1-6.7,5.091,32.448,32.448,0,0,1-9.337,3.106L61.511,79.45,47.228,82.079,9.474,54,8.012,46.05,15.9,44.6a32.457,32.457,0,0,0,6.744-1.963A20.559,20.559,0,0,0,27.9,39.5a14.543,14.543,0,0,0,3.48-4.165A11.84,11.84,0,0,0,32.8,30.219L3.321,35.644l3.907-8.935,24.056-4.428A12.764,12.764,0,0,0,24.64,15.9q-4.559-1.993-11.538-.708L0,17.6,3.907,8.666Z",
    fill: "#fcc659"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(214.64 333.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M179.415,338.6A25.257,25.257,0,0,1,190.9,350.647h0a25.343,25.343,0,0,1,11.5-12.067h0a25.29,25.29,0,0,1-11.5-12.045h0A25.316,25.316,0,0,1,179.415,338.6Z",
    transform: "translate(-179.415 -326.535)",
    fill: "#ffe6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(77.538 71.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M228.776,378.805a14.682,14.682,0,0,1,6.673,7h0a14.711,14.711,0,0,1,6.681-7.012h0a14.692,14.692,0,0,1-6.681-7h0A14.709,14.709,0,0,1,228.776,378.805Z",
    transform: "translate(-228.776 -371.793)",
    fill: "#ffe6a6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylater);
export default __webpack_public_path__ + "static/media/Pay later.cee698f44c3be788b2049f7e742e3631.svg";
export { ForwardRef as ReactComponent };